<script setup lang="ts">
import IconField from 'primevue/iconfield'
import InputIcon from 'primevue/inputicon'
import InputText from 'primevue/inputtext'

interface Props {
  modelValue?: string
  placeholder?: string
  disabled?: boolean
}

withDefaults(defineProps<Props>(), {
  modelValue: '',
  disabled: false,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()
</script>

<template>
  <IconField class="search-field">
    <InputIcon class="pi pi-search search-icon" />
    <InputText
      class="search-input"
      :modelValue="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      @update:modelValue="(v) => emit('update:modelValue', String(v))"
    />
  </IconField>
</template>

<style scoped>
.search-field {
  width: 100%;
}

/* IconField IS the scoped root (.search-field), so the `:deep()` ancestor must
   walk INTO IconField — not look for `.search-field` again as a descendant.
   The earlier `:deep(.search-field …)` form silently failed to match, leaving
   the input at its default PrimeVue width (~212px) instead of filling the
   wrapper. */
:deep(.search-input.p-inputtext) {
  height: 42px;
  border-radius: 8px;
  font-size: 0.875rem;
  width: 100%;
  padding-left: 2.5rem;
}

:deep(.search-icon) {
  color: var(--p-text-muted-color);
  font-size: 0.875rem;
}
</style>
